<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Je eigen bedrijfsdashboard met filterbare resultaten
    (filters: leeftijd / geslacht / provincie)
  </div>
</template>

<script>
export default {
  name: 'CommercialDashboard',
};
</script>
